export const PRODUCT_CATEGORIES = [
  "Men's Clothing",
  "Women's Clothing",
  "Kids' Clothing",
  "Food - Health - Beauty",
  "Accessories",
  "Home & Living",
] as const;

export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number];

export const CATEGORY_DISPLAY_NAMES: Record<ProductCategory, string> = {
  "Men's Clothing": "Men's Clothing",
  "Women's Clothing": "Women's Clothing",
  "Kids' Clothing": "Kids' Clothing",
  "Food - Health - Beauty": "Food, Health & Beauty",
  Accessories: "Accessories",
  "Home & Living": "Home & Living",
};
